/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useCallback, useState, useMemo } from 'react';
import UIModal from 'UIComponents/dialog/UIModal';
import UIForm from 'UIComponents/form/UIForm';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import { updateCrmObject } from './api/crmObjectsAPI';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { alwaysUndefined } from '../../utils/alwaysUndefined';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClickToAssignModal = ({
  objectTypeId,
  objectId,
  propertyDefinition,
  currentValue,
  onClose,
  onSuccess,
  onFailure
}) => {
  const [selectedOwner, setSelectedOwner] = useState(currentValue);
  const handleChange = useCallback(changes => setSelectedOwner(changes[propertyDefinition.name]), [propertyDefinition.name]);
  const handleSubmit = useCallback(event => {
    event.preventDefault();
    const propertyValues = [{
      name: propertyDefinition.name,
      value: selectedOwner
    }];
    return updateCrmObject({
      objectTypeId,
      objectId,
      propertyValues
    }).then(() => {
      onSuccess(propertyValues);
      onClose();
    }).catch(() => {
      onFailure(propertyValues);
      onClose();
    });
  }, [objectId, objectTypeId, onClose, onFailure, onSuccess, propertyDefinition.name, selectedOwner]);
  const formControlProps = useMemo(() => ({
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.clickToAssign.label"
    })
  }), []);
  return /*#__PURE__*/_jsx(UIModal, {
    children: /*#__PURE__*/_jsxs(UIForm, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.clickToAssign.title"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(PropertyInputV2, {
          formControlProps: formControlProps,
          objectTypeId: objectTypeId,
          objectId: objectId,
          property: propertyDefinition,
          value: selectedOwner,
          onChange: handleChange,
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined
          // Temporarily disable validation in UIs that don't require it.
          // To re-enable, wire up `onValidationChange` to disable saving.
          ,
          disableValidation: true
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "confirm-click-to-assign",
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.clickToAssign.assign"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "cancel-click-to-assign",
          use: "secondary",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.clickToAssign.cancel"
          })
        })]
      })]
    })
  });
};
export default ClickToAssignModal;